class Btn_Cart {
	constructor() {
		this.selectors = {
			document: document,
			add_Cart: '.js-add-cart',			
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
		$(document).ready(() => {
			if ( $(window).width() <= 1199 && $('.btn_cart_text').length ) {
				$('.btn_cart_text').remove();
				$('.btn_cart_block').removeClass('text');
			}
		});

		// Button adds product to Cart
		this.nodes.document.on('click', this.selectors.add_Cart, (e) => {
			e.preventDefault();
			var $this = $(e.currentTarget),
				imgToDrag = $this.closest('.js-content').find("img:not(.brand_img, .moldova_img)").eq(0),
				closure_block = $this.closest('.js-content').find("#popup-closure-block"),
				cart = $('.js-cart').filter(':visible'),
				cartCount = $('.js-cart-count').filter(':visible'),
				total_count = 0,
				url = $this.attr('data-href'),
				count = 1,
				action = true,
				quantity = $this.closest('.js-content').find('.js-quantity');
			if (quantity.length > 0 ){
				url = url + '&products_count=' + quantity.val()
				count = parseInt(quantity.val())
			}
			$this.hasClass('disabled') ? action = false : action = true;
			if (action) {
				$.ajax({
					url: url,
					type: 'POST',
					success: function(result) {
						// console.log(result)
						if (result.success == true) {
							// Cart count
							total_count = parseInt(cartCount.text()) + count;
							if (result.total_count <= 999) {
								cartCount.text(total_count);								
							} else
								cartCount.text('999+');							

							if ($('#js-total-sum').length) $('#js-total-sum').text(`${result.total_sum.toFixed(2)} MDL` || `${result.total_client.toFixed(2)}&nbsp;MDL` || '0');

							// Product image flies to cart
							// if (imgToDrag) {
							// 	var imgClone = imgToDrag.clone()
							// 		.offset({
							// 			top: imgToDrag.offset().top,
							// 			left: imgToDrag.offset().left
							// 		})
							// 		.css({
							// 			'opacity': '0.5',
							// 			'position': 'absolute',
							// 			'height': '150px',
							// 			'width': '150px',
							// 			'z-index': '100'
							// 		})
							// 		.appendTo($('body'))
							// 		.animate({
							// 			'top': cart.offset().top + 10,
							// 			'left': cart.offset().left + 10,
							// 			'width': 75,
							// 			'height': 75
							// 		}, 1000, 'easeInOutExpo');
							// 	imgClone.animate({
							// 		'width': 0,
							// 		'height': 0
							// 	});
							// }
						}
					}
				});
			}
			if(!($this.hasClass('popup_btn'))){
                closurePopup($(closure_block));
            }

		});

		function closurePopup(element) {
	        $.magnificPopup.open({
		        items: {
		            src: $(element)
		        },
				type: 'inline',
			});
			if( ($(element).find(".slickClosureProducts")).length > 0 ){
				slickClosureProducts($(element).find(".slickClosureProducts"));
			}
	    }
		
	    function slickClosureProducts(Slider) {
	        Slider.slick({
	            dots: true,
	            infinite: true,
	            accessibility: false,
	            speed: 300,
	            vertical: false,
	            slidesToShow: 3,
	            slidesToScroll: 3,
	            lazyLoad: 'ondemand',
	            prevArrow: '<button class="slick-prev"><i class="icon-custom icon1-arrow-left-3"></i></button>',
	            nextArrow: '<button class="slick-next"><i class="icon-custom icon1-arrow-right-3"></i></button>',
	            responsive: [{
	                breakpoint: 1199,
	                settings: {
	                    slidesToShow: 2,
	                    slidesToScroll: 2,
	                    infinite: false
	                }
	            }, {
	                breakpoint: 767,
	                settings: {
	                    slidesToShow: 1,
	                    slidesToScroll: 1
	                }
	            }]
	        });
	    }


	}
}
new Btn_Cart();
